// Builds a PostgREST `.or()` filter doing ILIKE over several columns.
// The search box text used to be interpolated raw: a comma or parenthesis
// ("Silva, João", "ACME (filial)") broke the filter syntax and the list came
// back as an error; `%`/`_` acted as wildcards. The term is wrapped in double
// quotes (PostgREST's reserved-char escape) and LIKE wildcards are escaped.

export function ilikeAnyFilter(columns: string[], term: string): string {
  const pattern = term.replace(/[\\%_]/g, (c) => `\\${c}`).replace(/"/g, '\\"');
  return columns.map((col) => `${col}.ilike."%${pattern}%"`).join(",");
}
